import * as Output from "../../Text";
import { isEuCitizen } from "../../common/countryCheck";

const permitMandatory = (nationality, country) =>
  !isEuCitizen(nationality) && country === "DE";

export const nonEuMandatory = (field, fields) =>
  permitMandatory(fields.nationality, fields.country) &&
  (!field || field.length <= 0)
    ? Output.resolve("generic.errors.M001_mandatoryFields")
    : undefined;

export const residencePermitEndDateMandatory = (field, fields) =>
  permitMandatory(fields.nationality, fields.country) &&
  fields.residencePermitStatus === "restricted" &&
  (!field || field.length <= 0)
    ? Output.resolve("generic.errors.M001_mandatoryFields")
    : undefined;

export const workPermitEndDateMandatory = (field, fields) =>
  permitMandatory(fields.nationality, fields.country) &&
  fields.workPermitStatus === "restricted" &&
  (!field || field.length <= 0)
    ? Output.resolve("generic.errors.M001_mandatoryFields")
    : undefined;
